












import AlertInfo from "@/components/AlertInfo.vue";
import AlertForm from "@/components/AlertForm.vue";
import { Alert, DeliveryConfig } from "@/types/alert";
import { Settings } from "@/types/settings";
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component({ components: { AlertInfo, AlertForm } })
export default class AlertsAdd extends Vue {
  created() {
    this.alert.description = this.settings.label;
  }
  @Getter("settings/activeCacheSettings") settings!: Settings;

  alert: Alert = {
    id: 0,
    trigger_type: "",
    trigger_threshold: null,
    delivery_config_id: null,
    description: "",
    enabled: true,
  };

  deliveryConfig: DeliveryConfig = {
    id: 0,
    delivery_type: "",
    email: "",
    slack_url: "",
    slack_channel: "",
  };

  cancel() {
    this.$emit("cancelAddAlert");
  }
}
